import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../store/slices'
import { useEffect } from 'react'

const useFetchDocuments = () => {
  const dispatch = useDispatch()
  const { userDetailsState } = useSelector((state) => state.authentication)
  const { ftuDocumentsWithoutVisit: documents, loading } = useSelector(
    (state) => state.records,
  )
  useEffect(() => {
    fetchDocuments()
  }, [])

  const fetchDocuments = () => {
    const payload = {
      patient_id: userDetailsState?.data?.patientID,
      report_type: 'pi',
      // Return only the current plan cycle's documents. A patient who renews holds one
      // invoice per plan, and without this the newest one wins — so a returning patient
      // would see the previous plan's approved invoice instead of being asked to upload
      // a new one. The backend resolves which plan that is; nothing is sent from here.
      planScoped: true,
    }
    new Promise((resolve, reject) => {
      dispatch(
        actions.fetchLiverFTUDocumentsWithoutVisitRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
  }

  // TODO: Need to export the loading state
  return {
    fetchDocuments,
    documents,
    loading,
  }
}
export default useFetchDocuments
